import { useEffect, useState } from 'react';

/**
 * Общий секундный тикер для отсчётов («до фандинга 12:34»).
 *
 * Отсчёт, заведённый состоянием страницы, раз в секунду перерисовывает её
 * целиком — в сканере это 500 строк ради одной колонки. Здесь подписываются
 * только маленькие компоненты-ячейки: тик перерисовывает их и больше ничего.
 * Таймер один на всех подписчиков и останавливается, когда их не осталось.
 * (В Funding.tsx тот же приём сделан локально — этот вариант общий.)
 */
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  if (timer === null) {
    timer = setInterval(() => { for (const l of listeners) l(); }, 1000);
  }
  return () => {
    listeners.delete(cb);
    if (listeners.size === 0 && timer !== null) { clearInterval(timer); timer = null; }
  };
}

/** Перерисовывает вызвавший компонент раз в секунду. */
export function useSecondTick(): void {
  const [, setTick] = useState(0);
  useEffect(() => subscribe(() => setTick(t => (t + 1) % 1_000_000)), []);
}
